import { render, staticRenderFns } from "./V2UnassignShipmentStep.vue?vue&type=template&id=5f355b31&scoped=true&"
import script from "./V2UnassignShipmentStep.vue?vue&type=script&lang=js&"
export * from "./V2UnassignShipmentStep.vue?vue&type=script&lang=js&"
import style0 from "./V2UnassignShipmentStep.vue?vue&type=style&index=0&id=5f355b31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f355b31",
  null
  
)

export default component.exports